import Axios from 'axios';

const customAxios = Axios.create();

export default customAxios;
